import type { SelectionOption } from '../types/SelectOption'
import RoundedCornersNone from '../images/rounded_corners_none.svg'
import RoundedCornersTheme from '../images/rounded_corners_theme.svg'

export const cornerRoundedOptions: SelectionOption[] = [
  { value: false, label: 'No rounded corners', image: RoundedCornersNone },
  { value: true, label: 'Theme corner radius', image: RoundedCornersTheme },
]